import React, { memo, ReactElement } from 'react';
import Content from 'reactApp/ui/Content/Content';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';

import { SelectFromCloudContent } from './components/Content/SelectFromCloudContent';
import styles from './SelectFromCloudPopup.css';
import { IProps } from './SelectFromCloudPopup.types';

export const SelectFromCloudPopup = memo(function SelectFromCloudPopup(props: IProps): ReactElement {
    const { onClose } = props;

    return (
        <Dialog open id="select-from-cloud" onCancel={onClose} className={styles.modal}>
            <Content isModal>
                <div className={styles.root}>
                    <div className={styles.title}>
                        Выберите фото и видео, чтобы добавить их в альбом
                    </div>

                    <SelectFromCloudContent {...props} />
                </div>
            </Content>
        </Dialog>
    );
});
